import { create } from "zustand";
import { Facility } from "../api/common/facility";

type FormState = Record<"origin" | "destination" | "products", "valid" | "invalid">;
export type Product = { name: string; sku: string; id: string; quantity: number };
export type InventoryTransferState = {
  form?: FormState;
  facility: {
    origin: Facility["name"] | null;
    destination: Facility["name"] | null;
  };
  products: Product[];
  setFacility: (key: "origin" | "destination", value: Facility["name"] | null) => void;
  setProducts: (products: Product[]) => void;
  validate: () => "valid" | "invalid";
  reset: () => void;
};

const initialState = { form: undefined, facility: { origin: null, destination: null }, products: [] };

export const useInventoryTransferStore = create<InventoryTransferState>()((set, get) => ({
  ...initialState,
  setFacility: (key, value) =>
    set((state) => {
      const facility = { ...state.facility, [key]: value };
      return { ...state, facility };
    }),
  setProducts: (products) => set((state) => ({ ...state, products })),
  validate: () => {
    set((state) => {
      const form: FormState = { origin: "valid", destination: "valid", products: "valid" };
      if (!get().facility.origin) form["origin"] = "invalid";
      if (!get().facility.destination) form["destination"] = "invalid";
      if (!get().products.length) form["products"] = "invalid";
      return { ...state, form };
    });
    return Object.values(get().form || {}).every((val) => val === "valid") ? "valid" : "invalid";
  },
  reset: () => set((state) => ({ ...initialState })),
}));
